const formatDate = (date: string) => {
  const parts = date.split("/");
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

const formatPickerDate = (date: string) => {
  const parts = date.split("-");

  if (parts.length !== 3) return date;

  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

const validateDate = (date: string) => {
  const parts = date.split("/").map((part) => parseInt(part));
  return !!(parts[2] && parts[1] && parts[0]);
};

const prettifyDate = (dateString: string) => {
  const parts = dateString.split("/");

  const date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);

  const dateFormatter = new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return `${dateFormatter.format(date)}`;
};

export const parseDatetimeFromDB = (dateString: string) => {
  const parts = dateString.split("/");

  const dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);

  return Date.parse(dt.toDateString());
};

export const parseDatetimeWithoutDaysFromDB = (dateString: string) => {
  const parts = dateString.split("/");

  const dt = new Date(`${parts[2]}-${parts[1]}-1`);

  return Date.parse(dt.toDateString());
};

// formatDateToString transforms Date -> dd/mm/yyyy
const formatDateToString = (date: Date) => {
  const year = date.toLocaleString("default", { year: "numeric" });
  const month = date.toLocaleString("default", { month: "2-digit" });
  const day = date.toLocaleString("default", { day: "2-digit" });

  return `${day}/${month}/${year}`;
};

export { formatDate, formatPickerDate, validateDate, prettifyDate, formatDateToString };
